export default __webpack_public_path__ + "static/media/platform_advantages_icon2.aa56449d.png";